// @import dependencies
import React, {Component} from 'react'
// @end

// @import components
import {CapsulasScreenLayout} from 'app_components/screens/landing/capsulas'
// @end

// @ADD Component types
interface ICapsulasScreenProps {}
interface ICapsulasScreenState {}

class CapsulasScreen extends Component<ICapsulasScreenProps, ICapsulasScreenState> {

  /*===============================================
  =            Estructura de un metodo            =
  ================================================
    // La estructura de un metodo debe ser la siguiente:
    methodName = () => {}
  /*======  End of Estructura de un metodo  =====*/

  constructor(props: ICapsulasScreenProps) {
    super(props)
    this.state = {}
  }

  render() {
    return(
      <CapsulasScreenLayout/>
    )
  }
}

export default CapsulasScreen
